import { useEffect, useState } from 'react'
import './AppointmentRibbonInfoItem.scss'
import { isEllipsisActive } from '../../../../utils/common'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const AppointmentRibbonInfoItem = ({ id, itemName, itemValue, isWithBorderBottom, isWithoutCapitalize }) => {
  const [isWithToolTip, setIsWithToolTip] = useState(false)
  const [isToolTipVisible, setIsToolTipVisible] = useState(false)

  useEffect(() => {
    if (isEllipsisActive(document.getElementById(id))) {
      setIsWithToolTip(true)
    }
  }, [])

  const tooltipConditionStyle = { visibility: isToolTipVisible ? 'visible' : 'hidden' }
  const itemNameConditionStyle = { borderBottom: isWithBorderBottom ? '1px solid #C2D5E2' : 'none' }
  const itemValueConditionStyle = { textTransform: isWithoutCapitalize ? 'none' : 'capitalize' }

  return (
    <div className='full-appointment-container'>
      {isWithToolTip ?
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        <div style={tooltipConditionStyle} className='appointment-tooltip-box'>
          {itemValue}
        </div>
      : null}
      <div id={id} className='appointment-item-block' style={itemNameConditionStyle}>
        {itemName}:{' '}
        <label
          style={itemValueConditionStyle}
          onMouseOver={() => setIsToolTipVisible(true)}
          onMouseLeave={() => setIsToolTipVisible(false)}>
          {itemValue}
          <div />
        </label>
      </div>
    </div>
  )
}

export default AppointmentRibbonInfoItem
